import QrVerification from '@/components/Auth/QrVerification'

const QrVerificationScreen = () => {
  return <QrVerification />
}

export default QrVerificationScreen
